<template>
  <div id="app">
    <!--商品详情页-->
<!--    <div class="container" v-if="!isDisplayCar">-->
    <div class="container">
      <div style="height: 50px;width: 100%"></div>1
      <div class="goods" v-for="(item,iindex) in listdata" :key="item.id">
        <img :src="item.imgs" :alt="item.name">
        <div class="price"><p>{{item.name}}  ￥{{item.price}}/{{item.unit}}</p></div>
        <div class="note" v-if="item.note">
          <p v-for="(noteitem,nindex) in item.notes">{{noteitem}}</p>
        </div>
        <button v-if="item.is_sell == 1" @click="addCar(item)">加入购物车</button>
        <button style="background-color: lightgray;border: 1px solid lightgray;color:black" v-if="item.is_sell != 1">库存不足</button>
      </div>
    </div>
    <!--购物车图标-->
    <div class="shoppingCar">
<!--      <button @click="displayCar">{{isDisplayCar==true?"返回":"购物车"}}</button>-->
      <button @click="displayCar" v-if="!isDisplayCar">购物车</button>
    </div>
    <!--订单查询图标-->
    <div class="shoppingCar" style="top:200px;">
      <button @click="jump('dingdanlie')" >订单信息</button>
    </div>
    <!--购物车页面-->
    <div class="car" v-if="isDisplayCar" >
      <h1>购物车</h1>
      <span class="closex" @click="isDisplayCar=false">X</span>
      <div class="goodsCarTitle">
        <div class="check">勾选状态</div>
        <div class="goodsImg">图片</div>
        <div class="goodsName">商品名称</div>
        <div class="goodsPrice">内售价</div>
        <div class="goodsNum">数量</div>
        <div class="action">操作</div>
      </div>
      <div style="height:400px;overflow-y: auto">
        <div class="goodsCar" v-for="(item2,index2) in carList" :key="item2.id">
          <input type="checkbox" id="checkbox" v-model="item2.isSelect" @change="selectGood">
          <img :src="item2.imgs" :alt="item2.name">
          <div class="carName"><p>{{item2.name}}</p></div>
          <div class="carPrice"><p>￥{{item2.price*item2.buynum}}</p></div>
          <div class="btnGroup">
            <button @click="addgoods(item2)">+</button>
            <input type="text" @change="check_goods_num(item2)" v-model="item2.buynum">
            <button @click="subgoods(item2)">-</button>
          </div>
          <button class="delete" @click="deleteA(item2)">删除</button>
        </div>
      </div>
      <div class="total">
        <input type="checkbox" v-model="selectAll" @change="selectAllGoods">全选
        <button class="deleteAll" @click="deleteAllGoods()">全部删除</button>
        <div class="totalPrice">
          总计：{{totalPrice}}元
          <button @click="topay">微信支付</button>
        </div>
      </div>
    </div>
    <!--付款码-->
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :show-close = "!dialogVisible"
      width="25%">

      <div style="position: relative;">
        <div style="position: absolute;top: -10px;" class="header">微信支付</div>
      </div>
      <div style="text-align: center;margin-top: 20px;">
        <img :src="scan_code" width="160"/><br/>
        <img src="/static/qmsj/img/weixinbiao_06.png"/>
        <p style="color: red;">支付成功前请勿关闭此页面,否则将导致充值失败!</p>
      </div>
    </el-dialog>
    <!--付款码END-->
  </div>
</template>
<script>
var baseUrl = process.env.apiUrl + "saas/";
export default {
  data() {
    return {
      token:'',
      listdata: [],//教具列表
      carList: [],//购物车中商品数据
      isDisplayCar: false,//是否展示购物车
      isSelect: false,//勾选框状态
      selectAll: false,//全选状态
      dialogVisible: false,//付款码弹窗
      scan_code: '',//付款二维码
      setT:'',  //清除持续调用
    }
  },
  computed: {
    //价格总数
    totalPrice() {
      var total = 0
      for (var i in this.carList) {
        if(this.carList[i].isSelect==true){
          total += this.carList[i].price * this.carList[i].buynum
        }
      }
      return total
    },
  },
  created() {
    this.token=this.$cookies.get('token');
    this.getlist(2)
  },
  methods: {
    //生成支付订
    topay() {
      let that = this;
      if (that.carList == '') {
        that.$message.error({
          message: '请先选择商品加入购物车'
        })
        return;
      }
      if (that.totalPrice == '0') {
        that.$message.error({
          message: '请先勾选需要购买的商品'
        })
        return;
      }
      $.ajax({
        url: baseUrl + "jiaoju/pay_order",
        type: "post",
        dataType: 'json',
        data: {
          token:that.token,
          carlist: that.carList
        },
        success: function (res) {
          if(res.status == 1){
            that.pay_code(res.order_id)
          }else{
            that.$message.error(res.msg)
          }
          that.dialogVisible = true
        }
      });
    },
    //生成支付 二维码
    pay_code(order_id){
      let that = this;
      if(!order_id){
        that.$message.error("未检测到订单信息,请重试");
      }
      $.ajax({
        url: process.env.apiUrl + 'weixinapi/example/jiaoju_pay_scan_code.php',
        // url: 'https://mapi.saas.cn/weixinapi/example/jiaoju_pay_scan_code.php',
        type: "post",
        dataType: 'json',
        data: {
          token:that.token,
          order_id: order_id
        },
        success: function (res) {
          // let d = JSON.parse(res)
          let d = res
          if (d.status == 1) {

            setTimeout(() => {
              $.ajax({
                url: process.env.apiUrl + 'saas/dx/qrcode',
                type: 'post',
                data: {
                  token: that.token,
                  data: d.scan_code
                },
                success: function (res2) {
                  if (res2.status == 1) {
                    that.scan_code = 'data:image/jpeg;base64,' + res2.img
                    that.setT = setInterval(() => {
                      that.pay_status(d.mch_no,order_id)
                    }, 3000)
                  }
                }
              })
            }, 300)
          }
        }
      });
    },
    //查询支付状态
    pay_status(mch_no,order_id) {
      let that = this
      if(!that.dialogVisible){
        clearInterval(that.setT)
        return;
      }
      $.ajax({
        url: process.env.apiUrl + 'weixinapi/example/jiaoju_pay_status_order.php',
        // url: 'https://mapi.momyhome.cn/weixinapi/example/jiaoju_pay_status_order.php',
        type: 'post',
        data: {
          token: that.token,
          out_trade_no: mch_no,
          order_id: order_id,
        },
        success: function (data) {
          if (JSON.parse(data) == 'SUCCESS') {
            clearInterval(that.setT)
            that.dialogVisible = false
            that.$message({
              message: '支付成功',
              type: 'success'
            })
            //购买成功清空购物车
            that.carList = '';
            setTimeout(() => {
              that.$router.push({path: 'dingdanlie'})
            }, 500)

          }
        }
      })
    },
    jump(url){
      this.$router.push({path: url})
    },
    //关闭付款框
    handleClose(done) {
      this.$confirm('取消支付将导致支付失败,是否确认？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    //获取教具列表
    getlist(type) {
      let that = this;
      that.chosetype = type;
      $.ajax({
        url: baseUrl + "jiaoju/get_list",
        type: "post",
        dataType: 'json',
        data: {
          token:that.token,
          type: type
        },
        success: function (res) {
          that.listdata = res.data;
        }
      });
    },
    //点击图标展示购物车页面
    displayCar() {
      if(this.isDisplayCar){
        this.isDisplayCar = !this.isDisplayCar
      }else{
        if (this.carList == '') {
          alert('购物车为空，请添加你喜欢的商品')
        } else {
          this.isDisplayCar = !this.isDisplayCar
        }
      }

    },
    //加入购物车页面
    addCar(goods) {
      if (this.carList == '') {
        goods.isSelect = true;
        this.carList.push(goods)
      } else {
        if (this.carList.includes(goods)) {
          var index = this.carList.indexOf(goods)
          this.carList[index].buynum = this.carList[index].buynum + this.carList[index].one_buy_num;
        } else {
          goods.isSelect = true;
          this.carList.push(goods)
        }
      }
    },
    //删除购物车中单项商品
    deleteA(goods) {
      var isDelete = confirm("确认删除吗？")
      if (isDelete) {
        var index = this.carList.indexOf(goods)
        this.carList.splice(index, 1)
      }
    },
    //增加商品数量
    addgoods(goods) {
      goods.buynum = goods.buynum + goods.one_buy_num;
    },
    //减少商品数量
    subgoods(goods) {
      if (goods.buynum > goods.min_num) {
        goods.buynum = goods.buynum - goods.one_buy_num;
      } else {
        goods.buynum = goods.min_num
      }
    },
    //手动修改商品数量
    check_goods_num(goods){
      if (goods.buynum <= goods.min_num) {
        this.$message.error("当前商品"+goods.min_num+goods.unit+"起购");
        goods.buynum = goods.min_num
      }
    },
    /**
     * 1.全选按钮需求：
     *  选中全选按钮，上面的所有的按钮都会被选中
     *  取消选中按钮，下面的所有按钮也会被取消选中
     * 2.除全选按钮之外的其他按钮需求
     *  其他按钮全部被选中，全选按钮也跟着被选中
     *  其他按钮只要有一个没有被选中，全选按钮也不会被选中
     */
    //全选按钮需求
    selectAllGoods() {
      for (var i in this.carList) {
        this.carList[i].isSelect = this.selectAll
      }
    },
    //除全选按钮之外的其他按钮需求
    selectGood() {
      var res=true
      for (var i in this.carList) {
        if(this.carList[i].isSelect==false){
          res=false
          break
        }
      }
      this.selectAll=res
    },
    //删除全部勾选商品
    deleteAllGoods(){
      var isDeleteAll = confirm("确认删除全部已勾选商品吗？")
      if(isDeleteAll){
        this.carList=this.carList.filter((item)=>{
          return item.isSelect!=true
        })
      }
    }
  }
};
</script>
<style scoped>
.container{
  width: 1000px;
  height: 900px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  background-color: lightblue;
}
.goods{
  width: 300px;
  height: 350px;
  text-align: center;
  background-color: lightblue;
}
.goods img{
  width: 200px;
  height: 220px;
  margin-top: 10px;
  margin-left: 10px;
}
.price{
  /*margin-left: 50px;*/
  text-align: center;
  height: 30px;
  line-height: 30px;
}
.price p{
  font-size: 18px;
  /*color: red;*/
  margin: 0;
  font-weight: 600;
  text-align: center;
}
.name{
  width: 100%;
  height: 30px;
  line-height: 30px;
}
.note{
  width: 100%;
  height: 30px;
  /*line-height: 30px;*/
}
.name p{
  text-align: center;
  font-weight: 600;
  margin: 10px 0;
}
.goods button{
  width: 200px;
  height: 40px;
  border-radius: 15px;
  margin-top: 10px;
  margin-left: 10px;
  background-color: #E6BE8A;
  border: 1px solid #E6BE8A;
  color: #FFF;
  font-size: 18px;
}


.shoppingCar{
  position: fixed;
  top: 100px;
  left: 1700px;
  width: 80px;
  height: 80px;
}
.shoppingCar button{
  width: 80px;
  height: 80px;
  background-color: #E6BE8A;
  border: 1px solid #E6BE8A;
  border-radius: 50%;
  font-size: 16px;
  color: #FFF;
}

.car{
  width: 1000px;
  margin: 0 auto;
  margin-top: 150px;
  background-color: lightgray;
  position: absolute;
  top: 0;
  left: 452px;
  border-radius: 15px;
  /*min-height: 500px;*/
  /*max-height: 600px;*/
  /*overflow-y: auto;*/
  /*overflow-x: hidden;*/
}
.car h1{
  padding: 15px;
  margin: 0;
  width: 1000px;
  height: 30px;
  text-align: center;
  /*line-height: 30px;*/
  color: #E6BE8A;
  font-size: 25px;
  font-weight: 600;
}
.goodsCarTitle{
  width: 950px;
  height: 50px;
  line-height: 50px;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
}
.closex{
  position: absolute;
  top:0;
  right: 10px;
  color: red;
  font-weight: bold;
  font-size: 18px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  text-align: center;
  /*border: 1px solid red;*/
}
.goodsCar{
  width: 950px;
  height: 80px;
  line-height: 80px;
  margin: 10px auto;
}
#checkbox{
  width: 30px;
  height: 30px;
  margin: 0 10px;
  margin-top: 25px;
  float: left;
}
.goodsCar img{
  width: 80px;
  height: 80px;
  margin-left: 120px;
  float: left;
}
.carName{
  width: 150px;
  height: 80px;
  line-height: 80px;
  margin-left: 50px;
  float: left;
}
.carName p{
  text-align: center;
  font-size: 16px;
  height: 80px;
  line-height: 80px;
  margin: 0;
}
.carPrice{
  width: 100px;
  height: 80px;
  line-height: 80px;
  margin-left: 80px;
  float: left;
}
.carPrice p{
  text-align: center;
  font-size: 16px;
  height: 80px;
  line-height: 80px;
  margin: 0;
}
.btnGroup{
  width: 200px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  margin-left: 40px;
  float: left;
}
.btnGroup button{
  width: 30px;
  height: 30px;
  font-size: 18px;
  text-align: center;
  vertical-align: middle;
  line-height: 25px;
}
.btnGroup input{
  width: 31px;
  height: 31px;
  line-height: 31px;
  text-align: center;
  padding: 0;
}
.delete{
  float: left;
  width: 80px;
  height: 40px;
  background-color: red;
  border: 1px solid red;
  border-radius: 10px;
  color: #FFF;
  margin-top: 20px;
  line-height: 40px;
}


.total{
  width: 950px;
  height: 80px;
  line-height: 80px;
  margin: 0 auto;
}
.total input{
  width: 30px;
  height: 30px;
  margin: 0 10px;
  margin-top: 25px;
  float: left;
}
.deleteAll{
  width: 80px;
  height: 40px;
  background-color: red;
  border: 1px solid red;
  border-radius: 10px;
  color: #FFF;
  margin-top: 20px;
  margin-left: 50px;
  line-height: 40px;
}
.totalPrice{
  float: right;
  width: 300px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.totalPrice button{
  width: 150px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #02c75a;
  border: 2px solid #02c75a;
  color: #FFF;
  font-size: 20px;
  font-weight: 600;
  border-radius: 15px;
  margin-left: 20px;
}

</style>




// WEBPACK FOOTER //
// src/pages/jiaoju/yanshengpin.vue